
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Les 8 KPI pour mesurer le succès de vos campagnes SEA",
    description:
      "Découvrez les KPI indispensables pour analyser vos campagnes SEA : CPA, CTR, taux de conversion, etc. Apprenez à les suivre efficacement pour maximiser votre ROI.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
